import React from 'react';

interface ButtonProps {
  type: 'primary' | 'outline';
  size: 'xs' | 'small' | 'medium' | 'large';
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  fullWidth?: boolean;
  isRounded?: boolean;
  icon?: React.ReactNode;
  iconPosition?: 'left' | 'right';
  className?: string;
  disabled?: boolean;
}

const Button: React.FC<ButtonProps> = ({ type, size, children, onClick, fullWidth = false, isRounded = true, icon, iconPosition = 'left', className = '', disabled = false }) => {
  const baseClasses = 'font-semibold transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 whitespace-nowrap border border-gray-800';

  // append disabled class if disabled is true
  const disabledClass = disabled ? 'disabled:bg-gray-300 disabled:text-gray-500 disabled:cursor-not-allowed disabled:border-gray-300' : '';

  const typeClasses = {
    primary: 'text-white bg-black hover:bg-gray-800 focus:ring-black',
    outline: 'text-black border-2 bg-transparent hover:bg-black hover:text-white focus:ring-black',
  };
  const roundedClass = isRounded ? `rounded-3xl` : 'rounded-[4px]' ;
  const sizeClasses = {
    xs: 'px-2 py-1 text-xs',
    small: 'px-3 py-1 text-sm',
    medium: 'px-4 py-2 text-base',
    large: 'px-6 py-3 text-lg',
  };

  const buttonClasses = `${baseClasses} ${roundedClass} ${typeClasses[type]} ${sizeClasses[size]} ${fullWidth ? 'w-full' : ''} ${
    icon ? 'inline-flex items-center gap-0' : ''
  }`;

  return (
    <button className={`${buttonClasses} ${className} ${disabledClass}`} onClick={onClick} disabled={disabled}>
      {icon ? (
        <>
          {iconPosition === 'left' && <span className="mr-1.5">{icon}</span>}
          <span>{children}</span>
          {iconPosition === 'right' && <span className="ml-1.5">{icon}</span>}
        </>
      ) : children}
    </button>
  );
};

export default Button;